import {
  GET_PARTICIPANTS_BEGIN,
  GET_PARTICIPANTS_SUCCESS,
  GET_PARTICIPANTS_FAILURE,
  ADD_PARTICIPANT_BEGIN,
  ADD_PARTICIPANT_SUCCESS,
  ADD_PARTICIPANT_FAILURE,
  GET_ACTIVITIES_BEGIN,
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_FAILURE
} from "./actions"

const initialState = {
  loading: false,
  participants: [],
  participantsLoading: false,
  activities: [],
  activitiesLoading: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PARTICIPANTS_BEGIN:
      return { ...state, loading: true, participantsLoading: true }
    case GET_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        participantsLoading: false,
        participants: action.payload.participants
      }
    case GET_PARTICIPANTS_FAILURE:
      return {
        ...state,
        loading: false,
        participantsLoading: false,
        participants: []
      }

    case ADD_PARTICIPANT_BEGIN:
      return { ...state, loading: true, participantsLoading: true }
    case ADD_PARTICIPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        participantsLoading: false,
        participants: action.payload.participants
      }
    case ADD_PARTICIPANT_FAILURE:
      return { ...state, loading: false, participantsLoading: false }

    case GET_ACTIVITIES_BEGIN:
      return { ...state, loading: true, activitiesLoading: true }
    case GET_ACTIVITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        activitiesLoading: false,
        activities: action.payload.activities
      }
    case GET_ACTIVITIES_FAILURE:
      return {
        ...state,
        loading: false,
        activitiesLoading: false,
        activities: []
      }

    default:
      return state
  }
}
